import {getModule, Module, Mutation, VuexModule, Action, MutationAction} from 'vuex-module-decorators';
import store from '@/store';
import cart from '@/store/modules/cart';
import {FidelityCard} from '../models';
import {initState} from '../stateinit';
import to from 'await-to-js';
import handleError from '@/commons/errorHandler';
import {doUseBonus, getFidelity, getAppliedBonus} from '@/store/api';
import checkout from './checkout';

@Module({
    namespaced: true,
    name: 'fidelitycard',
    store,
    dynamic: true,
})
class FidelityCardModule extends VuexModule {
    public fidelityCard: FidelityCard = initState('fidelityCard');

    get hasUsed(): boolean {
        return this.fidelityCard.applied_bonus > 0;
    }

    @Mutation
    public setFidelityData(fidelityData: FidelityCard) {
        this.fidelityCard = fidelityData;
    }

    @Mutation
    public updateUsedBonus(amount: number) {
        this.fidelityCard.applied_bonus = amount;
    }

    @MutationAction({ mutate: ['fidelityCard'] })
    public async getFidelityCard() {
        const emptyFidelity = {
            fidelityCard: {
                bonus: 0,
                end_date: '',
                max_usable: 0,
                applied_bonus: 0,
                use_bonus_enabled: false,
            },
        };
        let fidelityData;
        let err;
        [err, fidelityData] = await to(getFidelity());

        if (err) {
           handleError(err);
           return emptyFidelity;
        }

        let errAppliedBonus;
        let appliedBonus;
        [errAppliedBonus, appliedBonus] = await to(getAppliedBonus());

        if (errAppliedBonus) {
            handleError(err);
            return emptyFidelity;
        }
        const bonus = fidelityData[0].value;
        // const countedPoints = fidelityData[0].countedPoints;
        const usableValueOnCart = fidelityData[0].usableValueOnCart;
        // const status = fidelityData[0].status;
        // const totalPointsCollected = fidelityData[0].totalPointsCollected;
        const endDate = fidelityData[0].endDate;

        return {
            fidelityCard: {
                bonus,
                end_date: endDate,
                max_usable: usableValueOnCart,
                applied_bonus: appliedBonus,
                use_bonus_enabled: true,
            },
        };
    }

    @Action
    public async useBonus(bonus: number): Promise<number> {
        let err: any;
        let applyRes: any;
        [ err, applyRes ] = await to(doUseBonus(bonus));
        if (err) {
            handleError(err);
        }

        return new Promise((resolve, reject) => {
            if (err) {
                reject(err);
            } else {
                this.updateUsedBonus(applyRes);
                if (checkout.giftCard.applied && bonus > 0) {
                    checkout.removeGiftCard();
                } else {
                    cart.getTotals();
                    checkout.getPaymentMethods();
                }
                resolve(applyRes);
            }
        });
    }
}

export default getModule(FidelityCardModule);

